/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

import useCookieConsent from '@/hooks/useCookieConsent.hook';
import CookieConsentBanner from '@/components/CookieConsent/CookieConsentBanner';
import { env } from '@/configs/env.config';

/* -------------------------------------------------------------------------- */
/*                                   Types                                    */
/* -------------------------------------------------------------------------- */

interface CookieConsentProviderProps {
  children: React.ReactNode;
}

/* -------------------------------------------------------------------------- */
/*                                 Component                                  */
/* -------------------------------------------------------------------------- */

export default function CookieConsentProvider({ children }: CookieConsentProviderProps) {
  const { updateConsent, shouldShowBanner } = useCookieConsent(env.physiomKine.clarity.projectId);

  const handleConsentChange = (analytics: boolean, advertising: boolean) => {
    updateConsent(analytics, advertising);
  };

  return (
    <>
      {children}
      {shouldShowBanner && (
        <CookieConsentBanner onConsentChange={handleConsentChange} />
      )}
    </>
  );
}
